export default __webpack_public_path__ + "static/media/notification-pin.9da59931.svg";